import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { uniformeModulo } from 'src/app/aplicaciones-modulos/spyral/diccionarios/uniformeModule';

@Injectable({
  providedIn: 'root'
})
export class ClothesService {

  diccionarioUrl: any;
  urlUniforme: string;
  constructor(private commom: CommonService,
    private utilServices: UtilsService) {
    this.urlUniforme = this.utilServices.getUniforme();
    this.diccionarioUrl = uniformeModulo.url.uniforme;
  }

  getAllClothes() {
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.clothes);
  } 

  findClothes(codigo: string){
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.clothes + '/'+ codigo);
  }

  createClothes(grupoSize: string, parametro: any) {
    return this.commom.peticionPostConHeader(this.urlUniforme + this.diccionarioUrl.clothes +'/'+ grupoSize, parametro);
  }

}
